<template>
<div >
    <v-toolbar flat color="white">
        <v-btn color="primary" dark class="mb-2" @click="newDialog=true; cancelFields()" round >ADD CATEGORY</v-btn>
        <v-spacer></v-spacer>
        <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        max-width="50px"
        class="pa-3"
        clearable
      ></v-text-field>
    
    </v-toolbar>

     <!-- Add new item modal -->
    <v-dialog persistent v-model="newDialog" max-width="750px">

        <v-card>
        <v-toolbar flat class="primary">
        <h1 class="headline white--text" >ADD CATEGORY</h1>
        </v-toolbar>

          <v-card-text>
            <v-container grid-list-xs>
              <v-layout wrap>

                <v-flex xs12 sm6 md6>
                  <v-text-field
                    prepend-icon="edit"
                    v-model="editedItem.name"
                    label="*Category Name"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>

                  <v-flex xs12 sm6 md6>
                  <v-text-field
                    prepend-icon="edit"
                    v-model="editedItem.description"
                    label="Category Description"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>

                 <v-flex xs12 sm6 md6>
                  <v-autocomplete
                    clearable
                    hide-no-data
                    flat
                    color="primary"
                    :items="communicationProtocols"
                    item-text="name"
                    item-value="id"
                    v-model="editedItem.communicationProtocolId"  
                    label="*Communication Protocol"
                    multiple> 
               </v-autocomplete>        
                </v-flex> 
               </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <small>*indicates required field</small>
            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click="saveNew">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Edit Modal -->
    <v-dialog persistent v-model="dialog" max-width="750px">
      <v-card>
       
        <v-toolbar flat class="primary">
        <h1 class="headline white--text" >EDIT CATEGORY</h1>
        </v-toolbar>

          <v-card-text>
            <v-container grid-list-xs>
              <v-layout wrap>
            
                 <v-flex xs12 sm6 md6>
                  <v-text-field
                    prepend-icon="edit"
                    v-model="editedItem.name"
                    label="*Category Name"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>

                 <v-flex xs12 sm6 md6>
                  <v-text-field
                    prepend-icon="edit"
                    v-model="editedItem.description"
                    label="Category Description"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>
             
                <v-flex xs12 sm6 md6>
                   <v-autocomplete
                    clearable
                    hide-no-data
                    flat
                    color="primary"
                    :items="communicationProtocols"
                    item-text="name"
                    item-value="id"
                    v-model="editedItem.communicationProtocolId"  
                    label="*Communication Protocol"
                    multiple>
               </v-autocomplete>       
                </v-flex> 
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <small>*indicates required field</small>
            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click="save" >Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
      
    <v-data-table
      :headers="headers"
      class="elevation-1"
      :expand="expand"
      :pagination.sync="pagination"
      :loading="isloading"
      :items="tagCategories"
      :rows-per-page-items="[10, 25, 50, 100]"
      item-key="name"
      align-center
    >
      <template v-slot:items="props" >
          <td class="justify-center layout px-0">
            <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
            <v-icon small @click="deleteItem(props.item.id)">delete</v-icon>
          </td>
          <td class="text-xs-center">{{props.item.name}}</td>
          <td class="text-xs-center">{{props.item.description}}</td>
          
      </template>
      <!-- Custom Row count and Paging text -->
      <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      <!-- No data Dispalay -->
    
    </v-data-table>
  </div>
</template>
 
<script>
import Api from "@/services/Api";
export default {
    props:["tagcategoriescomponent",
          "tagcategoriesinfo" ],
  data() {
    return {
    showDetails: true,
    isloading:true,
    loading: false, 
    expand: false,
    search: "",
    dialog: false,
    newDialog: false,
    pagination: { },
    headers: [
            {
        text: "Action",
        align: "center"
      },
      {
        text: "Name",
        align: "center",
        value: "name"
      },
      {
        text: "Description",
        align: "center",
        value: "description"
      }
    ],
    tagCategories: [],
    communicationProtocols: [],
    editedIndex: -1,
    editedItem: {
        name: "",
        description: "", 
        communicationProtocolId: [],
        isDeleted: false
    },
    defaultItem: {
        name: "",
        description: "", 
        communicationProtocolId: [],
        isDeleted: false
    },
  }
  },
  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;
      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
      search(value){
       const route= {
        search: this.$route.search
      }
       if ((this.search)){      
        route.query = {search: this.search}        
      }
      this.$router.push(route)      
    
    },
    '$route.query':{
      immediate: true,
      async handler(value){
        this.tagCategories= await this.searchTagCategories(value)
      }
    },
     '$route.query.search':{
      immediate: true,
      handler(value){
        this.search=value
      },
    }, 
  },
  created() {
    this.initialize();
  },
  methods: {
    cancelFields(){
       this.editedItem.name="",
       this.editedItem.description="",    
       this.editedItem.communicationProtocolId=[]   
    },
     searchTagCategories(search){
       this.isloading =true
      if(search.search!==""){      
        Api()
        .get('/tagCategories/getall',{
          params: {
          search: search.search,
         }
          })
        .then(response=>{
          this.tagCategories=response.data
          this.isloading =false
        })} 
      },
    fetchTagCategories() {
        this.isloading =true
      Api()
        .get("/tagCategories/getall")
        .then(response => {
          this.tagCategories = response.data;
          this.isloading =false
        });      
    },
     fetchCommunicationProtocols() {
      Api()
        .get("/communicationProtocols/getall")
        .then(response => {
          this.communicationProtocols = response.data;
          this.isloading =false
        });      
    },
    initialize() {
     this.fetchTagCategories();
     this.fetchCommunicationProtocols()
    },
    editItem(item) {
      this.editedIndex = this.tagCategories.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.communicationProtocolId = []
      this.dialog = true;
       for(let i=0; i<item.tagCategoryCommunicationProtocols.length; i++){
           this.editedItem.communicationProtocolId.push(item.tagCategoryCommunicationProtocols[i].communicationProtocolId)
         }
    },
      deleteItem(id) {
      confirm("Are you sure you want to delete this item?") &&
      Api().put("/tagCategories/" + id, {
          isDeleted: true
        }).then(response => {
            this.fetchTagCategories();
        })
    },
    close() {
      this.dialog = false;
      this.newDialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    save() {
      let tagCatCommProtocolList = []
      let communicationProtocolList = []
       tagCatCommProtocolList = this.editedItem.tagCategoryCommunicationProtocols
       communicationProtocolList = this.editedItem.communicationProtocolId
      let tagCatId = this.editedItem.id
       let proceed = true;
      if (this.editedItem.name == "") {
        proceed = false;
        confirm("Please enter a name.");
      }
      if (communicationProtocolList.length == 0) {
        proceed = false;
        confirm("Please select a communication protocol.");
      }
      if (proceed == true) {
        Api().put("/tagCategories/" + this.editedItem.id, {
          name: this.editedItem.name,
          description: this.editedItem.description,      
          isDeleted: this.editedItem.isDeleted
        }).then(response => {
          for(let jj =0; jj<tagCatCommProtocolList.length; jj++){
            Api().put("/tagCategoryCommunicationProtocols/" + tagCatCommProtocolList[jj].id, {
              isDeleted:true
            })}
          }).then(response => {
         for(let i=0; i<communicationProtocolList.length; i++){
             Api()
        .post("/tagCategoryCommunicationProtocols", {
          tagCategoryId: tagCatId,
          communicationProtocolId: communicationProtocolList[i]
        })
           }
           this.fetchTagCategories();
          })
        this.close();
      }
      },
      saveNew() {
        let communicationProtocolList = this.editedItem.communicationProtocolId
      let proceed = true;
      if (this.editedItem.name == "") {
        proceed = false;
         confirm("Please enter a name.");
      }
        if (communicationProtocolList.length == 0) {
        proceed = false;
        confirm("Please select a communication protocol.");
      }
      if (proceed == true) {
        Api().post("/tagCategories", {
          name: this.editedItem.name,
          description: this.editedItem.description,     
          isDeleted: this.editedItem.isDeleted
        }).then(response => {
          let tagCatId = response.data.id          
         this.fetchTagCategories();
         Api().delete("/tagCategoryCommunicationProtocols/deleteByValue")        
            for(let i=0; i<communicationProtocolList.length; i++){
             Api()
        .post("/tagCategoryCommunicationProtocols", {
          tagCategoryId: tagCatId,
          communicationProtocolId: communicationProtocolList[i]
        })
         }
         this.fetchTagCategories();
        })
        
        this.close();
    }
  }
  }
};
</script>